/*
 * @Description:
 * @Version: 1.0
 * @Author: changfeng
 * @Date: 2024-04-09 09:49:13
 * @LastEditors: changfeng
 * @LastEditTime: 2024-08-12 15:09:52
 */
export default {
	"automatedRules.manageRules.blank.message":
		"You don’t have any automated rules.You can create automatic rules to automatically adjust the settings of a selected campaign,ad group or ad if it meets certain conditions",
	"automatedRules.manageRules.blank.button": "Create a rule",

	"automatedRules.manageRules.title": "Manage rules",
	"automatedRules.manageRules.tip": "There may be a certain degree of delay in closing or settlement on the Facebook platform",
	"automatedRules.manageRules.search.text": "Search by rule name",
	"automatedRules.manageRules.filter.text": "Filter by ad account",
	"automatedRules.manageRules.limit.text": "Created rules:",
	"automatedRules.manageRules.createRule": "Create rule",
	"automatedRules.manageRules.table.column1": "Name",
	"automatedRules.manageRules.table.column2": "Operation",
	"automatedRules.manageRules.table.delete": "Delete",
	"automatedRules.manageRules.table.edit": "Edit",
	"automatedRules.manageRules.table.share": "Share",
	"automatedRules.manageRules.table.copy": "Copy",

	"automatedRules.manageRules.table.delete.confirm.title": "Delete rule?",
	"automatedRules.manageRules.table.delete.confirm.content":
		"If you delete this automated rule, it will not run again. Are you sure you want to delete it?",

	"automatedRules.rulesMarket.title": "Rules market",
	"automatedRules.rulesMarket.table.column1": "Name",
	"automatedRules.rulesMarket.table.column2": "Operation",

	"automatedRules.actionHistory.title": "Action history",
	"automatedRules.actionHistory.search.text": "Search by rule name",
	"automatedRules.actionHistory.filter.text": "Filter by ad account",
	"automatedRules.actionHistory.table.column1": "Ad account",
	"automatedRules.actionHistory.table.column2": "Rule name",
	"automatedRules.actionHistory.table.column3": "Action",
	"automatedRules.actionHistory.table.column4": "Scope",
	"automatedRules.actionHistory.table.column5": "ScopeID",
	"automatedRules.actionHistory.table.column5.tooltip": "The time range of data that you'd like to include.",
	"automatedRules.actionHistory.table.column6": "Time of action",

	"automatedRules.actionHistory.table.column7": "Time range",
	"automatedRules.actionHistory.table.column8.tooltip":
		"The time range of data that you'd like to include.(The report time zone is the registered account time zone)",

	"automatedRules.actionHistory.table.column1.placeholder": "Please enter ad account ID",
	"automatedRules.actionHistory.table.column2.placeholder": "Please enter rule name",
	"automatedRules.actionHistory.table.column3.placeholder": "Please choose action",
	"automatedRules.actionHistory.table.column4.placeholder": "Please choose scope",
	"automatedRules.actionHistory.table.column5.placeholder": "Please enter scopeID",
	"automatedRules.actionHistory.table.column6.placeholder": "Please choose start time",
	"automatedRules.actionHistory.table.column7.placeholder": "Please choose end time ",

	"automatedRules.editStrategy.strategyName.label": "Rule name",
	"automatedRules.editStrategy.strategyName.placeholder": "please enter rule name",
	"automatedRules.editStrategy.adv.desc": "Select up to {{count}} ad accounts you want to manage",
	"automatedRules.editStrategy.adv.label": "Ad account",
	"automatedRules.editStrategy.latitude.label": "Scope",
	"automatedRules.editStrategy.latitude.camapign": "Campaign",
	"automatedRules.editStrategy.latitude.adgroup": "Ad group",
	"automatedRules.editStrategy.latitude.ad": "Ad",
	"automatedRules.editStrategy.apply rule to": "Apply rule to",
	"automatedRules.editStrategy.Active": "Active",
	"automatedRules.editStrategy.Inactive": "Inactive",
	"automatedRules.editStrategy.timeRange": "Effective period",
	"automatedRules.editStrategy.timeRange.toolTip": "Rules will take effect during this time period,(The timezone is account timezone)",

	"automatedRules.editStrategy.repeat": "Repeat frequency",
	"automatedRules.editStrategy.repeat.all time": "all the time",

	"automatedRules.editStrategy.repeat.once": "Once every 24 hours",
	"automatedRules.editStrategy.run.schedule.label": "Run schedule",
	"automatedRules.editStrategy.run.schedule.value": "Run every {{minuts}} minutes",

	"automatedRules.editStrategy.condition": "Condition",
	"automatedRules.editStrategy.action": "Action",
	"automatedRules.editStrategy.action.message": "Please enter numerical value",

	"automatedRules.batch.binding.strtegy.bulk operation": "Bulk Operation: ",
	"automatedRules.batch.binding.strtegy.bulk operation.item": "Bulk assign ad accounts",

	"automatedRules.account.bingding.strtegy.binging.state": "Rule Binding Status",
	"automatedRules.account.bingding.strtegy.binging.enable.state": "Rule Activation Status",
	"automatedRules.account.bingding.strtegy.binging.tip": "Turn on/off the switch to add/remove bindings to rules"
};
